import React, { useEffect, useState } from 'react'
import { getNotification, readNotification } from '../../asiosConfig';
import { toast } from 'react-toastify';
import { Card, CardHeader } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import boyImg from "../../images/blankPicBoy2.png";
import gitlImg from "../../images/blankPic3.png";

export const Notification = () => {
  const [notification, setNotification] = useState([]);
  const navigate = useNavigate();
  const gender = localStorage.getItem('gender');
  const defaultImage = gender === 'F' ? boyImg :  gitlImg ;
 
  useEffect(() => {
    const fetchNotification = async () => {

      try {
        const response = await getNotification({ 'page_no': 1 });
        if (response.status === 200 || response.status === 201) {
          setNotification(response.data.notifications);
        } else {
          toast.error('Error fetching notification');
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    };
    fetchNotification();
  }, []);

  // const handleNotificationClick = (sender_id, id) => {
  //   try {
  //     readNotification({ notification_id: id });
  //     navigate('/profile-view', { state: { user_id: sender_id } });
  //   } catch (error) {
  //     toast.error('Something Went Wrong:', error);
  //   }
  // }

const handleNotificationClick = (item) => {
  console.log("🔔 Notification clicked", {
    notification_id: item.id,
    sender_id: item.sender_id,
    sender_name: item.sender_name,
  });

  try {
    readNotification({ notification_id: item.id });

    console.log("➡️ Navigating to ProfileView with state:", {
  userId: item.sender_id,
  username: item.sender_name,
});

    navigate("/profile-view", {
      state: {
       userId: item.sender_id, 
      },
    });
  } catch (error) {
    console.error("❌ Notification click error", error);
    toast.error("Something went wrong");
  }
};



  return (
    <div className="col-lg-9 col-12">
      <div className="editProfileBlock">
        <div className="prodileDetailsBlock mt-3">
          <CardHeader
            avatar={
              <ArrowBack sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />
            }
            title="Notification"
            titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
          />
          {notification.length === 0 ? (
            <p>No New Notification</p>
          ) : (
            notification.map((item, index) => (
              <div key={index}
                className="d-flex justify-content-between align-items-center notiSec text-left"
                onClick={() => handleNotificationClick(item)}
                style={{
                  cursor: 'pointer',
                  backgroundColor: item.read === 0 ? '#f0f0f0' : 'transparent', // light color for read notifications
                  padding: '10px',
                  borderRadius: '8px',
                  marginBottom: '10px',
                }}>
                <div className="d-flex align-items-start">
                  <img
                   src={item?.photo || defaultImage} 
                    alt="Notification"
                    style={{
                      borderRadius: '50%',
                      width: '40px',
                      height: '40px',
                      marginRight: '10px',
                    }}
                  />
                  <div style={{ maxWidth: 'calc(100% - 60px)', wordWrap: 'break-word' }}>
                    {item.notify_msg}
                  </div>
                </div>
                <div style={{ marginLeft: '10px', whiteSpace: 'nowrap', textAlign: 'right' }}>
                  <p style={{ margin: 0 }}>{item.last_modified_date}</p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
